import api from './axiosInstance';
import { BasketAPI } from './basketApi';

export interface OrderItem {
  id: number;
  orderId: number;
  name: string;
  code: string;
  brand: string;
  count: number;
  pricePerUnit: number;
  basePricePerUnit: number;
  totalPrice: number;
  deliveryDate: string;
}

export interface Order {
  id: number;
  userId?: string;
  anonymousId?: string;
  fio: string;
  phone: string;
  email?: string;
  deliveryAddress?: string;
  comment?: string;
  totalPrice: number;
  created: string;
  status: OrderStatus;
  items: OrderItem[];
}

export enum OrderStatus {
  New = 'New',
  Processing = 'Processing',
  Shipping = 'Shipping',
  Delivered = 'Delivered',
  Cancelled = 'Cancelled'
}

export interface CreateOrderRequest {
  anonymousId?: string;
  firstName: string;
  lastName?: string;
  phone: string;
  email?: string;
  deliveryAddress?: string;
  comment?: string;
}

export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
}

export const orderApi = {
  createOrder: async (orderData: Omit<CreateOrderRequest, 'anonymousId'>): Promise<ApiResponse<Order>> => {
    const token = localStorage.getItem('token');
    try {
      if (token) {
        // Если есть токен, делаем авторизованный запрос
        const response = await api.post('order', orderData);
        return {
          success: true,
          data: response.data
        };
      } else {
        // Если токена нет, делаем анонимный запрос
      const anonymousId = BasketAPI.getAnonymousId();
      const request: CreateOrderRequest = {
        ...orderData,
        anonymousId
      };
      const response = await api.post('order/anonymous', request);
      return {
        success: true,
        data: response.data
      };
      }
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Ошибка при создании заказа'
      };
    }
  },

  getUserOrders: async (): Promise<ApiResponse<Order[]>> => {
    const token = localStorage.getItem('token');
    try {
      if (token) {
        // Если есть токен, делаем авторизованный запрос
        const response = await api.get('order');
        return {
          success: true,
          data: response.data
        };
      } else {
        // Если токена нет, делаем анонимный запрос
        const anonymousId = BasketAPI.getAnonymousId();
        const response = await api.get(`order/anonymous/${anonymousId}`);
      return {
        success: true,
        data: response.data
      };
      }
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Ошибка при получении заказов'
      };
    }
  },

  getOrderDetails: async (orderId: number): Promise<ApiResponse<Order>> => {
    const token = localStorage.getItem('token');
    try {
      if (token) {
        // Если есть токен, делаем авторизованный запрос
      const response = await api.get(`order/details/${orderId}`);
      return {
        success: true,
        data: response.data
      };
      } else {
        // Если токена нет, делаем анонимный запрос
        const anonymousId = BasketAPI.getAnonymousId();
        const response = await api.get(`order/anonymous/details/${orderId}?anonymousId=${anonymousId}`);
        return {
          success: true,
          data: response.data
        };
      }
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || 'Ошибка при получении деталей заказа'
      };
    }
  }
}; 